module.exports = __webpack_public_path__ + "static/img/A162.22ea4c09.jpg";